export default __webpack_public_path__ + "static/media/Hockey Stadium, PKL2.0c88547f.jpg";